import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../components-v2/Theme/theme';
import { background, brandPrimaryText } from '../../../../../../../styles/colors';
import { BrowserMediaQueries, CssSelectors } from '../../../../../../../styles/styles';

const entityConversationComposerContactHeaderHeight = 60;
const entityConversationComposerHeaderHeight = 16;

export const styleSheet = StyleSheet.create({
	container: {},
	entityConversationComposer: {
		height: '100%',
	},
	entityConversationComposerConversation: {
		background: THEME.colors.background.main,
		display: 'flex',
		flex: '1 0 30%',
		flexDirection: 'column',
		height: `calc(100% - ${entityConversationComposerContactHeaderHeight + entityConversationComposerHeaderHeight}px)`,
		...CssSelectors.allChildren(
			{
				display: 'flex',
				flexDirection: 'column-reverse',
				flexGrow: 1,
				padding: '10px 20px',
				[BrowserMediaQueries.IE11]: {
					'-ms-overflow-style': 'none',
					flexDirection: 'column',
					transform: 'rotate(180deg)',
				},
			},
			'.conversation'
		),
		...CssSelectors.allChildren(
			{
				padding: '8px 20px 20px',
			},
			'.text-message-input'
		),
	},
	entityConversationComposerConversationContactHeader: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		height: entityConversationComposerContactHeaderHeight,
		justifyContent: 'center',
	},
	entityConversationComposerConversationHeader: {
		alignItems: 'center',
		display: 'flex',
		height: entityConversationComposerHeaderHeight,
		justifyContent: 'flex-end',
	},
	modalClassName: {
		...CssSelectors.allDescendants(
			{
				height: 'calc(100vh - 100px)',
				width: 620,
			},
			'.modal-overlay-content'
		),
		...CssSelectors.allDescendants(
			{
				borderLeft: 'none',
				borderRight: 'none',
			},
			'.conversation-container'
		),
	},
	textBubbleContainer: {
		background,
		padding: 20,
	},
	textShowMore: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: 10,
		...CssSelectors.allChildren({
			color: brandPrimaryText,
			cursor: 'pointer',
			fontSize: 14,
		}),
	},
	loadingSpinnerContainer: {
		position: 'relative',
		top: '50%',
	},
	conversationMessagesContainer: {
		display: 'flex',
		flexDirection: 'column-reverse',
		flexGrow: 1,
		padding: '10px 20px',
		overflowY: 'auto',
		[BrowserMediaQueries.IE11]: {
			'-ms-overflow-style': 'none',
			flexDirection: 'column',
			transform: 'rotate(180deg)',
		},
	},
	dateSeparator: {
		display: 'flex',
		justifyContent: 'center',
		padding: '10px 0',
		fontSize: 12,
		...CssSelectors.allChildren({
			padding: '2px 8px',
			borderRadius: THEME.common.borderRadius,
		}),
	},
	// Legacy styles for backward compatibility
	modal: {
		maxWidth: 600,
		width: '90vw',
		maxHeight: '80vh',
		margin: 'auto',
		borderRadius: 8,
		overflow: 'hidden',
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '20px 24px',
	},
	headerContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	title: {
		margin: 0,
		fontSize: 18,
		fontWeight: 600,
	},
	recipientInfo: {
		gap: 4,
	},
	recipientName: {
		fontSize: 14,
		fontWeight: 500,
	},
	recipientPhone: {
		fontSize: 12,
	},
	messagesContainer: {
		flex: 1,
		padding: '16px 24px',
		overflowY: 'auto',
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		minHeight: 300,
		maxHeight: 'calc(80vh - 160px)',
	},
	noMessages: {
		textAlign: 'center',
		fontSize: 14,
		padding: '40px 20px',
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-end',
		padding: '16px 24px',
	},
});
